import ProjectContent from "./ProjectContent";
import ProjectLeader from "./ProjectLeader";
import ProjectMetadata from "./ProjectMetadata";
import DevelopmentStageTag from "./DevelopmentStageTag";
import ProjectNeedsTag from "./ProjectNeedsTag";
import classes from "./classes.module.scss";
import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import { usePoster } from "../hooks/usePoster";
import { useProjectConfig } from "../hooks/useProjectConfig";
import { useProjectLeader } from "../hooks/useProjectLeader";
import Social from "components/materials/SocialButton";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";

type IProps = {
	project: ProjectResponseResource;
};

export default function ProjectDetails(props: IProps) {
	const { projectConfig } = useProjectConfig();
	const { projectLeader, projectLeaderAvatar } = useProjectLeader();
	const { poster } = usePoster(props.project);
	const hasSocials = props.project.discord || props.project.instagram || props.project.x || props.project.linkedin;

	return (
		<div className={classes["root"]}>
			<div className={classes["content-container"]}>
				<div className={classes["header"]}>
					<div className={classes["metadata"]}>
						{projectLeader && <ProjectLeader contributor={projectLeader} avatar={projectLeaderAvatar} />}
						<ProjectMetadata project={props.project} />
					</div>
					<div className={classes["tags"]}>
						{projectConfig?.developmentStage && <DevelopmentStageTag value={projectConfig.developmentStage} />}
						{projectConfig?.projectNeeds && <ProjectNeedsTag value={projectConfig.projectNeeds} />}
					</div>
				</div>
				{projectConfig && <ProjectContent project={props.project} config={projectConfig} />}
				{hasSocials && (
					<div className={classes["socials"]}>
						<Typography type="p" size="medium" weight="medium">
							{I18n.asset.pages.my_projects.drawer.button.follow_us}
						</Typography>
						<Social project={props.project} />
					</div>
				)}
			</div>
			<div className={classes["poster-container"]}>{poster && <img src={poster} alt="Poster" className={classes["poster"]} />}</div>
		</div>
	);
}
